// src/components/CoverLetterTemplates.js
/**
 * Cover letter templates in HTML format
 * Each template function takes coverLetterData and returns HTML
 */

// Import templates from individual files
import {
  standardTemplateHtml,
  professionalTemplateHtml,
  creativeTemplateHtml,
  minimalTemplateHtml,
  templates,
  getTemplates,
} from "./coverLetterTemplates/index";

// Re-export all templates and functions
export {
  standardTemplateHtml,
  professionalTemplateHtml,
  creativeTemplateHtml,
  minimalTemplateHtml,
  templates,
  getTemplates,
};

export default templates;
